var map = {
	"./data-table-en": [
		99543,
		543
	],
	"./data-table-en.js": [
		99543,
		543
	],
	"./data-table-it": [
		4459,
		459
	],
	"./data-table-it.js": [
		4459,
		459
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 7 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 45320;
module.exports = webpackAsyncContext;